module.exports = __webpack_public_path__ + "assets/img/partner5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partner5.jpg
// module id = 1970
// module chunks = 0